import { Paper, Stack } from '@mui/material';
import { LinkReturnToMain } from 'Components';
import { Landing } from './Intro';
import { UserContacts } from './UserContacts';
import { useIsDesktop } from 'Hooks';

export const B2CFirstLoginLanding = () => {
  const isDesktop = useIsDesktop();
  return (
    <Stack gap='24px' sx={{ position: 'relative' }}>
      <LinkReturnToMain />
      <Paper
        sx={{
          mt: isDesktop ? undefined : '10px',
          maxWidth: '1000px',
          borderRadius: '24px',
          bgcolor: '#FFF',
          boxShadow: '0px 2px 24px 0px rgba(0, 0, 0, 0.16)',
          display: 'flex',
        }}
      >
        {isDesktop && <Landing />}
        <Stack
          sx={{
            p: isDesktop ? '40px 0' : '57px 0',
            maxWidth: '600px',
            textAlign: 'center',
          }}
        >
          <UserContacts />
        </Stack>
      </Paper>
    </Stack>
  );
};
